"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ChatbotDataProvider: ()=>ChatbotDataProvider
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_ChatbotDataContext_js_namespaceObject = require("./ChatbotDataContext.js");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
let chatRguid = '';
const ChatbotDataProvider = (props)=>{
    const { submitChatMessagesPayload, handleMarkerResponse, fetchRequestOptions, markerComponents, logFirstMessageSubmitted, logCustomerCarePhoneNumberDisplayed, logCustomerCarePhoneNumberClicked, enableVoice, enableVoiceTooltip, quickActions, quickActionsStackVariant, isMobile, setiValues, debugMode, discoveryCitySelected, speechFetchRequestOptions, transcriptionFetchRequestOptions, audioPlayerRef, isRealtime, isDev, setLoadMoreMessages, loadMoreMessages, shouldDisplayGenHotelFeature, componentVersion, requestFrom, retrieveUrl } = props;
    const { pushPrompt, enabledActions } = submitChatMessagesPayload ?? {};
    const [errorMessage, setErrorMessage] = (0, external_react_namespaceObject.useState)('');
    const [accountLessAccessToken, setAccountLessAccessToken] = (0, external_react_namespaceObject.useState)('');
    const [accountLessTripsAccessPayload, setAccountLessTripsAccessPayload] = (0, external_react_namespaceObject.useState)();
    const [isDisablingInput, setIsDisablingInputValue] = (0, external_react_namespaceObject.useState)(false);
    const [fullStreamingTexts, setStreamingText] = (0, external_react_namespaceObject.useState)('');
    const setAccountLessAccessTokenMemoFn = (0, external_react_namespaceObject.useMemo)(()=>({
            setAccountLessAccessToken
        }), [
        setAccountLessAccessToken
    ]);
    const funcValues = (0, external_react_namespaceObject.useMemo)(()=>({
            setErrorMessage,
            setIsDisablingInputValue,
            setStreamingText,
            setLoadMoreMessages,
            setAccountLessTripsAccessPayload
        }), [
        setErrorMessage,
        setIsDisablingInputValue,
        setStreamingText,
        setLoadMoreMessages,
        setAccountLessTripsAccessPayload
    ]);
    if (chatRguid) submitChatMessagesPayload.rguid = chatRguid;
    else chatRguid = submitChatMessagesPayload.rguid;
    const accountLessAccessTokensContext = {
        accountLessAccessToken,
        ...setAccountLessAccessTokenMemoFn
    };
    const contextValues = {
        isSessionActive: true,
        discoveryCitySelected,
        submitChatMessagesPayload,
        handleMarkerResponse,
        fetchRequestOptions,
        markerComponents,
        logFirstMessageSubmitted,
        logCustomerCarePhoneNumberDisplayed,
        logCustomerCarePhoneNumberClicked,
        quickActions,
        quickActionsStackVariant,
        isMobile,
        isRealtime,
        debugMode,
        isDev,
        loadMoreMessages,
        errorMessage,
        isDisablingInput,
        fullStreamingTexts,
        enableVoice,
        enableVoiceTooltip,
        setiValues,
        speechFetchRequestOptions,
        transcriptionFetchRequestOptions,
        pushPrompt,
        audioPlayerRef,
        shouldDisplayGenHotelFeature,
        componentVersion,
        shouldUseMapFeature: enabledActions?.shouldEnableInlineLocationMetadata,
        accountLessTripsAccessPayload,
        requestFrom,
        retrieveUrl,
        ...funcValues
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        analytics_js_default().init(contextValues);
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatbotDataContext_js_namespaceObject.ChatbotDataContext.Provider, {
        value: {
            ...contextValues,
            ...accountLessAccessTokensContext
        },
        children: props.children
    });
};
exports.ChatbotDataProvider = __webpack_exports__.ChatbotDataProvider;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChatbotDataProvider"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
